import React from 'react'
import NoRecordsFound from '../../product/components/atoms/NoRecordsFound'
import DashboardLayout from '../Dashboard/DashboardLayout'

const Payment = () => {
    return (
        <DashboardLayout>
            <NoRecordsFound />
        </DashboardLayout>
    )
}

export default Payment
